import React from 'react';

import RadialBars from '../../../components/charts/apex/radial-bars/RadialBars';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

function Trust({ domainEntries }) {
  return <RadialBars data={domainEntries} dataKey={SONAR_DATA_KEYS.TRUST} />;
}

export default Trust;
